<template>
  <div class="program-dashboard-table"> 
    <el-table
      class="program-dashboard-table el-table--simple"
      ref="table"
      row-key="id"
      :data="rows"
      v-loading="loading"
      @sort-change="doChangeSort"
      @row-click="onRowClick"
    >
    
      <!-- <el-table-column
        :resizable="false"
        v-if="hasPermissionToAuditLogs"
        :label="fields.id.label"
        :prop="fields.id.name"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'id') }}</template>
      </el-table-column> -->

      <el-table-column
        :resizable="false"
        :label="!isPropertyNBA ? fields.name.label : i18n('entities.season.fields.name')"
        :prop="fields.name.name"
      >
        <template slot-scope="scope">
          <span v-text="presenter(scope.row, 'name')"></span>
        </template>
      </el-table-column>

      <el-table-column
        :resizable="false"
        :label="!isPropertyNBA ? fields.type.label : i18n('entities.season.fields.type')"
        :prop="fields.type.name"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'type') }}</template>
      </el-table-column>

      <!-- <el-table-column
        :resizable="false"
        :label="fields.sport.label"
      >
        {{ presenter(currentManage.property, 'sport') }}
      </el-table-column> -->

      <el-table-column
        :resizable="false" v-if="!simple" :fixed="isMobile? undefined : 'right'" align="center" width="140">
        <template slot-scope="scope">
          <div class="table-actions">
            <router-link :to="`/program/${scope.row.id}/edit`" v-if="hasPermissionToEdit">
              <el-button
                icon="icon-pen"
                circle
              />
            </router-link>

            <el-button
              :disabled="destroyLoading"
              @click="doDestroyWithConfirm(scope.row.id)"
              v-if="hasPermissionToDestroy"
              icon="icon-trash"
              circle
            />
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { AuditLogPermissions } from '@modules/audit-log/audit-log-permissions';
import { ProgramModel } from '@modules/program/program-model';
import { mapGetters, mapActions } from 'vuex';
import { ProgramPermissions } from '@modules/program/program-permissions';
import { i18n } from '@shared/i18n';
import { propertyStatusTagType } from '@modules/property/property-enum-status';
import { propertyAccessTagType } from '@modules/property/property-enum-access';
import { getProgramTypeListByPropertyType } from '@shared/factories/enums-factory';
import { get } from 'lodash';

const { fields } = ProgramModel;

export default {
  name: 'app-program-dashboard-table',
  props: {
    simple: Boolean,
    maxItems: Number
  },
  mounted() {
    const propertyType = get(this, 'currentManage.property.type', null);
    const programs = getProgramTypeListByPropertyType(propertyType);
    this.activeTab = programs[0];
  },
  data() {
    return {
      activeTab: null
    };
  },
  computed: {
    ...mapGetters({
      allRows: 'program/list/rows',
      count: 'program/list/count',
      loading: 'program/list/loading',
      pagination: 'program/list/pagination',
      isMobile: 'layout/isMobile',
      currentUser: 'auth/currentUser',
      destroyLoading: 'program/destroy/loading',
      paginationLayout: 'layout/paginationLayout',
      currentManage: 'auth/manage/currentManage',
      isPropertyNBA: 'auth/manage/isPropertyNBA',
    }),

    rows() {
      if (!this.maxItems) return this.allRows;
      return this.allRows.slice(0, this.maxItems);
    },

    hasPermissionToAuditLogs() {
      return new AuditLogPermissions(this.currentUser).read;
    },

    hasPermissionToEdit() {
      return new ProgramPermissions(this.currentUser).edit;
    },

    hasPermissionToDestroy() {
      return new ProgramPermissions(this.currentUser)
        .destroy;
    },
    fields() {
      return fields;
    },
    rowsByProgramType() {
      return this.allRows.filter(row => {
        return row.type === this.activeTab;
      });
    },
    typeOptions() {
      const { programs } = this.currentManage.property;
      return fields.type.options.filter(({ id }) => {
        return programs.some(programId => programId === id);
      });
    },
  },

  methods: {
    ...mapActions({
      doChangeSort: 'program/list/doChangeSort',
      doChangePaginationCurrentPage: 'program/list/doChangePaginationCurrentPage',
      doChangePaginationPageSize: 'program/list/doChangePaginationPageSize',
      doDestroy: 'program/destroy/doDestroy',
    }),

    presenter(row, fieldName) {
      return ProgramModel.presenter(row, fieldName);
    },

    async doDestroyWithConfirm(id) {
      try {
        await this.$confirm(
          i18n('common.areYouSure'),
          i18n('common.confirm'),
          {
            confirmButtonText: i18n('common.yes'),
            cancelButtonText: i18n('common.no'),
            type: 'warning',
          },
        );

        return this.doDestroy(id);
      } catch (error) {
        // no
      }
    },

    propertyStatusTagType(status) {
      return propertyStatusTagType(status);
    },
    propertyAccessTagType(status) {
      return propertyAccessTagType(status);
    },
    handleTabClick({ label }) {
      this.activeTab = label;
    },
    onRowClick(row, column) {
      if (!('label' in column)) return;
    },
    i18n(code) {
      return i18n(code);
    },
  },
};
</script>
<style lang="scss">
.program-dashboard-table {
  &.el-table tr,
  &.el-table tr:hover>td {
    background-color: #ffffff;
    cursor: default;
  }
}
</style>
